export var PAYMENT_TYPES;
(function (PAYMENT_TYPES) {
  PAYMENT_TYPES["ONLINE"] = "ONLINE";
  PAYMENT_TYPES["CHECK"] = "CHECK";
  PAYMENT_TYPES["CASH"] = "CASH";
  PAYMENT_TYPES["BAD_DEBT"] = "BAD_DEBT";
})(PAYMENT_TYPES || (PAYMENT_TYPES = {}));